import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { Survey } from '@/types/survey';
import ajax from '@/utils/ajax';
import { errorMessage } from '@/utils/mapAxiosErrorMessages';

export const surveyRepository = {
  async getSurvey({ host, surveyId }: { host: string; surveyId: string }): Promise<Survey | void> {
    try {
      const path = `/api/dugout/surveys/${surveyId}/`;
      const { data } = await ajax.get({
        url: `${host}${path}`
      });

      return data;
    } catch (error) {
      await Promise.reject(`Failed to get survey. ${errorMessage(error as AxiosError)}`);
    }
  }
};

const SurveyRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getSurvey(surveyId: string): Promise<Survey | void> {
      return surveyRepository.getSurvey({ host, surveyId });
    }
  };
};

export default SurveyRepository;
